import { useStylesWithoutDuplicates } from './hooks';
export var LazyStylesComponent = function (_a) {
    var children = _a.children, styles = _a.styles, identifier = _a.identifier;
    useStylesWithoutDuplicates(identifier, styles);
    return children;
};
